import React, { memo } from 'react';

const LangSmall = memo(({ size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 2.79999H9.61333"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.68167 1.75V2.8" stroke="#5A5A5A" strokeMinecap="round" strokeLinejoin="round" />
      <path
        d="M8.35333 2.79999C8.35333 2.79999 7.67666 5.94415 2.95166 9.27499"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.82083 4.63165C3.82083 4.63165 4.84166 6.62665 6.81916 7.94499"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.34418 12.25L9.81168 6.03748L12.25 12.25"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 10.92H11.7308"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default LangSmall;
